<template>
	<div class="single-solutions">
		<div class="wrap">
        <div class="page-title">
					<p>Metals In Aqueous Solutions</p>
					<router-link to="/" class="btn hollow">Back To Home</router-link>
				</div>

				<div class="single-solutions-body">
					<div class="pick-a-metal">
						<h3 v-if="showInstructions">Pick A Metal.</h3>
						<div class="metal-btn-grid">
						

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'magnesium'}" 
							@click="startMetalImg = 'magnesium'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('magnesium')">
								Magnesium (Mg)
							</button>
							

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'tin'}" 
							@click="startMetalImg = 'tin'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('tin')">
								Tin (Sn)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'copper'}" 
							@click="startMetalImg = 'copper'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('copper')">
								Copper (Cu)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'zinc'}" 
							@click="startMetalImg = 'zinc'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('zinc')">
								Zinc (Zn)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'lead'}" 
							@click="startMetalImg = 'lead'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('lead')">
								Lead (Pb)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'nickel'}" 
							@click="startMetalImg = 'nickel'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('nickel')">
								Nickel (Ni)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'iron'}" 
							@click="startMetalImg = 'iron'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('iron')">
								Iron (Fe)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'silver'}" 
							@click="startMetalImg = 'silver'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('silver')">
								Silver (Ag)
							</button>

						
						</div>

						<div class="buttons">
							<button class="btn" @click="beginAnimate" v-if="showAnimateBtn" :key="1" :disabled="!startMetalImg || disableBtns">Continue</button>
							<button class="btn" @click="removeMetal" v-if="showRemoveBtn" :key="2" :disabled="!startMetalImg || disableBtns">Remove</button>
							<button class="btn" @click="redoConfirmed" v-if="redoConfirm" :key="4" :disabled="disableBtns">Yes, Repeat Experiment</button>
						</div>
					</div>

					<div class="beaker-contain">
						<AcidDunk
						:startBeakerImg="solution.startBeakerImg"
						:startMetalImg="startMetalImg"
						:reactions="solution.reactions"
						:formula="solution.formula"
						:animate="animate"
						:showEnd="showEnd"
						:lower="lower"
						:single="true"
						:showBubbles="showBubbles"
						:slowTrans="slowTrans"
						/>

						<transition name="fade">
							<MolecularModalAcid 
								v-if="showMolecularScaleBtn && startMetalImg != 'copper'" 
								:metal="startMetalImg"
								/>
							<MolecularModalAcidCopper
								v-if="showMolecularScaleBtn && startMetalImg === 'copper'" 
								/>

						</transition>
					</div>
				</div>
		</div>
	</div>
</template>


<script>
import { mapGetters } from 'vuex'
import AcidDunk from '../components/AcidDunk'
import MolecularModalAcid from '../components/MolecularModalAcid'
import MolecularModalAcidCopper from '../components/MolecularModalAcidCopper'

export default {
	name:"SingleSolutions",
	components:{
		AcidDunk,
		MolecularModalAcid,
		MolecularModalAcidCopper
	},
	data() {
		return {
			solution: {},
			metalsArr: [],
			animate: false,
			showInstructions: true,
			redoConfirm: false,
			confirmedRedo: false,
			showChooseMetal: false,
			showAnimateBtn: true,
			showRemoveBtn: false,
			disableMetalBtns: false,
			startMetalImg: false,
			alreadyDone: [],
			showEnd: false,
			lower: false,
			showBubbles: false,
			disableBtns: false,
			slowTrans: false,
			showMolecularScaleBtn: false
		}
	},
	computed: {
    ...mapGetters(['getPage'])
  },
	beforeMount() {
		let id = parseInt(this.$route.params.id)
		const page = this.getPage(id)
		this.solution = page.solutions[0]
		this.metalsArr = page.metals
	},
	methods: {
		beginAnimate(){

			if(this.alreadyDone.includes(this.startMetalImg) && !this.confirmedRedo){
				this.redoConfirm = true
				this.showAnimateBtn = false
				return
			} 
			this.showMolecularScaleBtn = true
			this.disableMetalBtns = true
			this.disableBtns = true
			if(this.confirmedRedo) this.confirmedRedo = false
			this.animate = true
			this.alreadyDone.push(this.startMetalImg)

			this.lower = true;
			this.slowTrans = true

			setTimeout(() => {
				this.showBubbles = true
				this.showEnd = true
			}, 500);

			setTimeout(() => {
				this.showAnimateBtn = false
				this.showRemoveBtn = true
				this.redoConfirm = false
				this.disableBtns = false
				this.slowTrans = false
				
			}, 5100);

			setTimeout(() => {
				this.showBubbles = false
			}, 5500);
		
		},
		removeMetal(){
			this.showAnimateBtn = true
			this.showRemoveBtn = false
			this.lower = false
			this.disableMetalBtns = false
			this.showBubbles = false

			setTimeout(() => {
				this.showMolecularScaleBtn = false
			}, 500);
		},
		redoConfirmed(){
			this.confirmedRedo = true
			this.showEnd = false
			setTimeout(() => {
				this.beginAnimate();
			}, 300);
			
		}
	},
}
</script>


<style lang="scss" scoped>

.single-solutions-body{
	display: grid;
	grid-template-columns: 1fr;
	grid-template-areas: 'beaker' 'metals';

	@media screen and (min-width: 800px) {
		grid-template-columns: 1fr 1fr;
		grid-template-areas: 'metals beaker';
	}

	.pick-a-metal{
		grid-area: metals;
		padding: 1em;
	}

	.beaker-contain{
		grid-area: beaker;
		position: relative;

		@media screen and (min-width: 800px) {
			.molecular-modal-btn{
				font-size: 1.5rem;
			}
		}
	}

	h3{
		font-size: 36px;
		font-weight: 400;
		color: $grey;
		margin-bottom: 0;
		margin-bottom: 2rem;
	}
}

.metal-btn-grid{
	display: grid;
	grid-template-columns: 1fr;
	grid-gap: 15px;
	margin-bottom: 1.5rem;

	@media screen and (min-width: 480px) {
		grid-template-columns: 1fr 1fr;
	}

	@media screen and (min-width: 1200px) {
		grid-template-columns: 1fr 1fr 1fr;
	}
}

.buttons{
	display: flex;
	justify-content: center;
	position: sticky;
	bottom: 0px;
	background: #fff;
	backdrop-filter: none;

	@media screen and (min-width: 800px) {
		position: static;
		justify-content: flex-start;
	}
}

.metal-btn{
		flex: 0 1 20%;
		background: none;
		border: solid 3px $bordergrey;
		color: $grey;
		font-weight: 400;
		font-size: 1.3rem;
		padding: .7rem 1.3rem;
		letter-spacing: .1rem;
		border-radius: 100px;
		margin: 0px;
		transition: all 250ms;

		&.active{
			background: $bordergrey;

			&:hover{
				background: $bordergrey;
				border-color: $bordergrey;
			}
		}

		&:hover{
			background: none;
			border-color: $blue;
			color: $grey;
		}

		&:disabled{
			opacity: .5;
		}
	}
</style>